/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import {
  Paper,
  MuiThemeProvider,
  Button,
  useMediaQuery,
  Tooltip,
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { actionTableMuiTheme } from "../table/table_styles";

import * as schoolDUCK from "../../../redux/ducks/school.duck";
import { setLoader } from "../../../redux/ducks/load.duck";
import { Add, Delete } from "@material-ui/icons";
import CustomTableFooter from "../../utils/CustomTableFooter";
import { setAlert } from "../../../redux/ducks/alert.duck";
import PlaylistDialog from "./components/PlaylistDialog";
import {
  getPlaylistsList,
  getPlaylist,
  deletePlaylist,
} from "../../crud/api/playlist.crud";
import { getContents } from "../../crud/api/content.crud";

const Playlist = ({ settingLoader, handleAlert }) => {
  const isDesktop = useMediaQuery("(min-width: 960px)");
  const [dialog, setDialog] = useState("close");
  const [playlists, setPlaylists] = useState([]);
  const [editingPlaylist, setEditingPlaylist] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const [contents, setContents] = useState([]);

  const getList = async (page = 1) => {
    const response = await getPlaylistsList(page, 10);
    setPlaylists(response.items || []);
    setTotalCount(response.total || 0);
    setCurrentPage(page);
  };

  const getContentsList = async () => {
    await getContents(setContents);
  };

  useEffect(() => {
    getList(1);
    getContentsList();
  }, []);

  const columns = [
    {
      name: "title",
      label: "Title",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "description",
      label: "Description",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "playlist_contents_attributes",
      label: "Content",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => {
          const length = value && Array.isArray(value) ? value.length : 0;
          return <span>{length} items</span>;
        },
      },
    },
    {
      name: "active",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <span className={`badge ${value ? "badge-success" : "badge-danger"}`}>
            {value ? "Active" : "Inactive"}
          </span>
        ),
      },
    },
    {
      name: "start",
      label: "Featured",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <span className={`badge ${value ? "badge-success" : "badge-danger"}`}>
            {value ? "Active" : "Inactive"}
          </span>
        ),
      },
    },
    {
      name: "id",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, meta) => (
          <div>
            <Tooltip title="Edit Playlist" placement="top">
              <a
                id={`edit_playlist_btn_${value}`}
                className="btn btn-icon btn-sm btn-light btn-hover-primary"
                onClick={() => handleOpenModal("editing", value)}
              >
                <i className="fas fa-edit text-primary" />
              </a>
            </Tooltip>
            <Tooltip title="Delete Playlist" placement="top">
              <a
                id={`delete_playlist_btn_${value}`}
                className="btn btn-icon btn-sm btn-light btn-hover-danger text-danger mx-3"
                onClick={() => handleDeletePlaylist(value)}
              >
                <Delete />
              </a>
            </Tooltip>
          </div>
        ),
      },
    },
  ];

  const options = {
    serverSide: true,
    rowsPerPageOptions: [],
    rowsPerPage: 10,
    page: currentPage,
    count: totalCount,
    rowHover: false,
    search: false,
    sort: false,
    print: false,
    filter: false,
    viewColumns: false,
    download: false,
    selectableRows: "none",
    tableBodyMaxHeight: isDesktop ? "50em" : "357px",
    textLabels: {
      body: {
        noMatch: "No data",
      },
      pagination: {
        next: "Next",
        previous: "Previous",
        rowsPerPage: "Rows:",
        displayRows: "of",
      },
    },
    downloadOptions: {
      filename: "school.csv",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayRowsOnly: true,
      },
    },
    customFooter: (count, page, rowsPerPage) => (
      <CustomTableFooter
        count={count}
        page={page}
        rowsPerPage={rowsPerPage}
        onChangePage={(mPage) => {
          settingLoader(true);
          getList(mPage)
            .catch(() => {})
            .finally(() => settingLoader(false));
        }}
      />
    ),
  };

  const handleOpenModal = async (mode, id = null) => {
    switch (mode) {
      case "create":
        settingLoader(true);
        setEditingPlaylist(null);
        setDialog(mode);
        break;
      case "editing":
        settingLoader(true);
        try {
          const playlistData = await getPlaylist(id);
          setEditingPlaylist(playlistData.playlist);
          setDialog(mode);
        } catch (error) {
          settingLoader(false);
        }
        break;
      case "close":
        setDialog(mode);
        setEditingPlaylist(null);
        break;
      default:
        break;
    }
  };

  const handleDeletePlaylist = (id) => {
    handleAlert({
      title: "Delete Playlist",
      message: "Are you sure to permanently delete this Playlist?",
      btn_msg: "Delete Playlist",
      action: () =>
        deletePlaylist(id).then(() => {
          getList(currentPage);
        }),
    });
  };

  return (
    <div style={{ padding: "20px" }}>
      <div className="pb-4 d-flex justify-content-end align-items-end">
        <Button
          id="create_playlist_btn"
          variant="contained"
          color="secondary"
          onClick={() => handleOpenModal("create")}
        >
          <Add /> Create New Playlist
        </Button>
      </div>
      <Paper>
        <MuiThemeProvider theme={actionTableMuiTheme()}>
          <MUIDataTable
            // title="Admin"
            columns={columns}
            data={playlists}
            options={options}
          />
        </MuiThemeProvider>
      </Paper>
      <PlaylistDialog
        mode={dialog}
        setDialog={handleOpenModal}
        playlist={editingPlaylist}
        onRefresh={getList}
        contents={contents}
      />
    </div>
  );
};

const mapStateToProps = (store) => ({
  schools: store.school.schools,
});

const mapDispatchToProps = (dispatch) => ({
  schoolActions: bindActionCreators(schoolDUCK.actions, dispatch),
  settingLoader: bindActionCreators(setLoader, dispatch),
  setAlertModal: bindActionCreators(setAlert, dispatch),
  handleAlert: bindActionCreators(setAlert, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Playlist);
